var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.props.subcomponent,{ref:_vm.props.id,tag:"component",attrs:{"id":_vm.props.id,"props":_vm.props.subcomponent_attributes},on:{"update":_vm.update}})
}
var staticRenderFns = []

export { render, staticRenderFns }